/**
 * サイト内の絶対パスに basename を足す。
 *
 * このアプリは 1 つのソースから 2 つのワーカーに出ている。
 * luagate.com はルート直下 (basename 無し)、yumesaku.tech は `/women` の下。
 *
 * React Router の `Link to` と `loader` の URL は basename を勝手に足してくれるが、
 * **`fetch()` の第1引数と、素の `<a href>` は足してくれない**。
 * そのため `/women` 側では `fetch("/api/payment-intent")` が
 * `https://yumesaku.tech/api/payment-intent` を叩き、別ワーカーの 404 に落ちる。
 * 決済も、体験申込も、問い合わせも、広告の CV 計測も、これで全部黙って死んでいた。
 *
 * 判定はビルド時に決まる定数で行う (vite.config.ts の define)。
 * 実行時に location を見る形にすると SSR で分岐が効かない。
 */
declare const __SITE_BASENAME__: string;

const BASENAME =
  typeof __SITE_BASENAME__ !== "undefined" ? __SITE_BASENAME__ : "";

/**
 * `/api/foo` → luagate.com では `/api/foo`、yumesaku.tech では `/women/api/foo`。
 *
 * 外部 URL とパス以外はそのまま返すので、呼ぶ側で場合分けしなくてよい
 */
export function sitePath(path: string): string {
  if (!BASENAME || !path.startsWith("/")) return path;
  if (path.startsWith(`${BASENAME}/`) || path === BASENAME) return path;
  return `${BASENAME}${path}`;
}
